<template>
  <q-dialog
    v-model="shown"
    transition-show="fade-in"
    transition-hide="fade-out"
  >
    <q-card style="min-width: 320px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Adjust Credit
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <model-form-input
          field="credit"
          label="New Credit Balance"
          type="number"
          min="0"
          step="0.01"
          :prefix="currentCircuit.localeCurrencySymbol"
          bottom-slots
        />
        <q-inner-loading :showing="saving" />
      </q-card-section>
      <q-card-actions class="row justify-between q-ma-sm">
        <q-btn
          v-show="!saving"
          class="col"
          label="Update Credit"
          color="primary"
          size="lg"
          @click="save"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'UserCreditAdjustmentDialog',
  configuration: ['currentCircuit'],
  props: {
    user: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['update:model-value', 'save'],
  data () {
    return {
      shown: false,
      saving: false
    }
  },
  watch: {
    shown () {
      if (!this.shown) {
        this.$emit('update:model-value', this.shown)
      }
    }
  },
  methods: {
    async show () {
      this.shown = true
    },
    async save () {
      try {
        this.saving = true
        await this.user.adjustCredit()
      } finally {
        this.$emit('save')
        this.saving = false
        this.shown = false
      }
    }
  }
}

</script>
